type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
};

export default function ListViewIcon({
  width = '18',
  height = '18',
  strokeColor = 'currentColor',
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="2"
        y1="4.5"
        x2="16"
        y2="4.5"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="2"
        y1="9"
        x2="16"
        y2="9"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="2"
        y1="13.5"
        x2="16"
        y2="13.5"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
